module.exports = __webpack_public_path__ + "static/media/bg-cross-sell-vertical.td.c1f491a3.jpg";